<template>
  <div class="home">
    <Header :pageIndex="0"/>
    <div class="banner-list">
      <img :class="bannerIndex==index?'banner-img active':'banner-img'" v-for="(item,index) in bannerList" :key="index"
           :src="item.url">
      <div class="poster-text">
        <div class="poster-text-title">{{bannerList[bannerIndex].title}}</div>
        <div class="poster-text-title">{{bannerList[bannerIndex].title2}}</div>
        <div class="poster-text-desc">{{bannerList[bannerIndex].content}}</div>
      </div>
      <div class="point-list">
        <div @click="changeBanner('count',index)" :class="index==bannerIndex?'point-item active':'point-item'"
             v-for="(item,index) in bannerList"></div>
      </div>
      <div class="pre-icon" @click="changeBanner('pre')"></div>
      <div class="next-icon" @click="changeBanner('next')"></div>
    </div>
    <CTitle title="/static/service-around.png" desc="Scope of services"/>
    <CSevice/>
    <CTitle title="/static/about-us.png" desc="About Us"/>
    <CUs/>
    <div class="product-section">
      <div class="product-bg"></div>
      <CTitle title="/static/product-service.png" desc="Product service"/>
      <CProduct/>
    </div>
  </div>
</template>

<script>
  import CSevice from "@/components/CSevice";
  import CTitle from "@/components/CTitle";
  import CUs from "@/components/CUs";
  import CProduct from "@/components/CProduct";
  import Header from "@/components/Header";

  var timer;
  export default {
    name: 'Home',
    components: {CProduct, CUs, CTitle,Header, CSevice},
    data() {
      return {
        count: 0,
        bannerIndex: 0,
        bannerList: [{
          url: "static/home/banner1.png",
          title:'檀浏信息',
          title2:'行业产品解决方案专业提供商',
          content: "成为连接企业管理与信息技术的桥梁，帮助企业实现数字化转型，以信息化手段帮助客户提高组织的运营效率、效益与竞争能力，实现客户价值"
        }, {
          url: "static/home/banner2.png",
          title:'檀浏信息',
          title2:'行业产品解决方案专业提供商',
          content: "成为连接企业管理与信息技术的桥梁，帮助企业实现数字化转型，以信息化手段帮助客户提高组织的运营效率、效益与竞争能力，实现客户价值"
        }, {
          url: "static/home/banner3.png",
          title:'檀浏信息',
          title2:'行业产品解决方案专业提供商',
          content: "成为连接企业管理与信息技术的桥梁，帮助企业实现数字化转型，以信息化手段帮助客户提高组织的运营效率、效益与竞争能力，实现客户价值"
        }, {
          url: "static/home/banner4.png",
          title:'小程序电商系统',
          title2:'满足您的运营场景',
          content: "小程序商城解决方案致力于为企业提供多渠道电商解决方案，通过自建商城，以及营销系统、会员系统帮助企业搭建新一代微商城销售体系，快速实现去中心化流量聚合，客户粉丝沉淀，助力企业快速步入移动电商时代"
        }]
      }
    },
    methods: {
      changeBanner(type, toIndex) {
        let index = this.bannerIndex
        if (type == 'pre') {
          index--;
        } else if (type == 'next') {
          index++;
        } else {
          index = toIndex
        }
        index = (index + this.bannerList.length) % this.bannerList.length
        this.bannerIndex = index
        this.count = 0
      }
    },
    mounted() {
      timer = setInterval(() => {
        let count = this.count + 1
        this.count = count
        if (count == 5) {
          this.changeBanner('next')
        }
      }, 1000)
    },
    destroyed() {
      timer && clearInterval(timer)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .banner-list {
    width: 100%;
    min-width:1200px;
    height: 600px;
    position: relative;
  }

  .banner-img {
    width: 1920px;
    height: 600px;
    position: absolute;
    left: 50%;
    top: 0;
    margin-left: -960px;
    opacity: 0;
    -webkit-transition: opacity 0.6s ease-in-out;
    -moz-transition: opacity 0.6s ease-in-out;
    -o-transition: opacity 0.6s ease-in-out;
    transition: opacity 0.6s ease-in-out;
  }

  .banner-img.active {
    opacity: 1;
    -webkit-transition: opacity 0.6s ease-in-out;
    -moz-transition: opacity 0.6s ease-in-out;
    -o-transition: opacity 0.6s ease-in-out;
    transition: opacity 0.6s ease-in-out;
  }

  .pre-icon {
    width: 45px;
    height: 45px;
    position: absolute;
    top: 50%;
    margin-top: -22px;
    left: 40px;
    background-image: url("../../../static/home/jtz.png");
    transition: left 0.5s;
    cursor: pointer;
  }

  .pre-icon:hover {
    background-image: url("../../../static/home/jtyzz.png");
    width: 55px;
    left: 30px;
    transition: left 0.5s;
  }

  .next-icon {
    width: 45px;
    height: 45px;
    position: absolute;
    top: 50%;
    margin-top: -22px;
    right: 44px;
    background-image: url("../../../static/home/jty.png");
    transition: right 0.5s;
    cursor: pointer;
  }

  .next-icon:hover {
    background-image: url("../../../static/home/jtyy.png");
    width: 55px;
    right: 30px;
    transition: right 0.5s;
  }

  .point-list {
    width: 1100px;
    position: absolute;
    bottom: 60px;
    left: 50%;
    margin-left: -550px;
    display: flex;
  }

  .point-item {
    width: 13px;
    height: 13px;
    background: #3058FF;
    border-radius: 3px;
    margin-right: 10px;
    cursor: pointer;
    transition: background-color 0.8s;
  }

  .point-item.active {
    background-color: #FCE504;
    transition: background-color 0.8s;
  }

  .poster-text {
    top: 245px;
    left: 50%;
    margin-left: -520px;
    position: absolute;
  }
  .poster-text-title{
    font-size: 38px;
    font-family: YouSheBiaoTiHei;
    color: #FFFFFF;
    line-height: 49px;
  }
  .poster-text-desc{
    margin-top: 14px;
    width: 429px;
    font-size: 16px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 26px;
    opacity: 0.5;
  }

  .product-section {
    width: 100%;
    height: 507px;
    position: relative;
  }

  .product-bg {
    width: 1920px;
    height: 507px;
    position: absolute;
    bottom: 0;
    left: 50%;
    margin-left: -960px;
    z-index: -1;
    background-image: url("../../assets/bg3.png");
  }
</style>



// WEBPACK FOOTER //
// src/components/contains/Home.vue